export default "__VITE_ASSET__878a0aa9__"